// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1JDyk","content":"RecentSearches_content__21tj5"};